window.addEventListener('DOMContentLoaded', () => {
    let resender = document.querySelector('.resender');
    let confirmation = document.querySelector('.confirmation');

    resender.querySelector('.resender__button').addEventListener('click', () => {
        resender.style.display = 'none';
        confirmation.style.display = 'block';

        setTimeout(() => {
            resender.style.display = 'block';
            confirmation.style.display = 'none';
        }, 10000)
    });
});